import createDisplayName from "../../../../../fabrics/createDisplayName";
import { CORE_HEADER_DISPLAY_NAME } from "../CoreHeader";

export const createDisplayNameForCoreHeader = createDisplayName(
    CORE_HEADER_DISPLAY_NAME,
);
